type SpaceCreateForm = {
  id: string;
  name: string;
};

export default SpaceCreateForm;
